module.exports = __webpack_public_path__ + "img/ic_64_distance.64b64c9d.svg";